import React, { Component } from 'react';
import './styles.scss';
import { Form, FormTitle, FormContent, FormInput, FormButton } from '../Form';
import CreateSessionMutation from '../../mutations/CreateSession';

const initialState = {
	name: ''
};
class AddSessionForm extends Component {
	constructor(props) {
		super(props);
		this.state = initialState;
	}
	createSession(createSessionMutation) {
		const { onSessionCreated } = this.props;
		const { name } = this.state;
		createSessionMutation({ variables: { name } }).then(mutation => {
			onSessionCreated(mutation.data.createSession);
		});
	}
	render() {
		const { name } = this.state;
		const disabled = !name;
		return (
			<CreateSessionMutation>
				{createSessionMutation => (
					<Form className="AddSessionForm" style={{ height: 'auto' }}>
						<FormTitle>Add Session</FormTitle>
						<FormContent>
							<FormInput
								onChange={e => this.setState({ name: e.target.value })}
								type={'text'}
								placeholder={'Name'}
								value={name}
								style={{ margin: '0 auto' }}
							/>
							<FormButton
								disabled={disabled}
								onClick={() => this.createSession(createSessionMutation)}
							>
								Create New
							</FormButton>
						</FormContent>
					</Form>
				)}
			</CreateSessionMutation>
		);
	}
}

export default AddSessionForm;
